// Claims the tab strip the markup renders inert. Until this runs the panels are stacked
// and open, so a reader without JavaScript loses the control, never the content.
class ProductTabs extends HTMLElement {
  connectedCallback() {
    this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
    this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));

    // One panel is not a choice, so it stays open and unadorned.
    if (!this.hasAttribute('data-tabbed') || this.tabs.length < 2) return;

    this.classList.add('is-enhanced');
    this.tabs.forEach((tab, index) => {
      tab.setAttribute('tabindex', index === 0 ? '0' : '-1');
      tab.addEventListener('click', () => this.select(index));
      tab.addEventListener('keydown', (event) => this.onKeydown(event, index));
    });
    this.select(0);
  }

  select(index) {
    this.tabs.forEach((tab, position) => {
      const isSelected = position === index;
      tab.setAttribute('aria-selected', isSelected ? 'true' : 'false');
      tab.setAttribute('tabindex', isSelected ? '0' : '-1');
      this.panels[position]?.toggleAttribute('hidden', !isSelected);
    });
  }

  onKeydown(event, index) {
    const offsets = { ArrowRight: 1, ArrowLeft: -1 };
    let target;

    if (event.key in offsets) {
      target = (index + offsets[event.key] + this.tabs.length) % this.tabs.length;
    } else if (event.key === 'Home') {
      target = 0;
    } else if (event.key === 'End') {
      target = this.tabs.length - 1;
    } else {
      return;
    }

    event.preventDefault();
    this.select(target);
    this.tabs[target].focus();
  }
}

customElements.define('product-tabs', ProductTabs);
